import React from 'react';
import {Icon as ChakraIcon} from '@chakra-ui/react';

import {ReactComponent as SvgActivity} from './tabler/outline/activity.svg';
import {ReactComponent as SvgAdjustmentsHorizontal} from './tabler/outline/adjustments-horizontal.svg';
import {ReactComponent as SvgAlertCircle} from './tabler/outline/alert-circle.svg';
import {ReactComponent as SvgAlertOctagon} from './tabler/outline/alert-octagon.svg';
import {ReactComponent as SvgAlertTriangle} from './tabler/outline/alert-triangle.svg';
import {ReactComponent as SvgArrowLeft} from './tabler/outline/arrow-left.svg';
import {ReactComponent as SvgArrowRight} from './tabler/outline/arrow-right.svg';
import {ReactComponent as SvgArrowUp} from './tabler/outline/arrow-up.svg';
import {ReactComponent as SvgArrowUpRight} from './tabler/outline/arrow-up-right.svg';
import {ReactComponent as SvgAward} from './tabler/outline/award.svg';
import {ReactComponent as SvgBolt} from './tabler/outline/bolt.svg';
import {ReactComponent as SvgBook} from './tabler/outline/book.svg';
import {ReactComponent as SvgBraces} from './tabler/outline/braces.svg';
import {ReactComponent as SvgBriefcase} from './tabler/outline/briefcase.svg';
import {ReactComponent as SvgBrandWindows} from './tabler/outline/brand-windows.svg';
import {ReactComponent as SvgBuilding} from './tabler/outline/building.svg';
import {ReactComponent as SvgCalendar} from './tabler/outline/calendar.svg';
import {ReactComponent as SvgCalendarClock} from './tabler/outline/calendar-clock.svg';
import {ReactComponent as SvgChartBar} from './tabler/outline/chart-bar.svg';
import {ReactComponent as SvgCheck} from './tabler/outline/check.svg';
import {ReactComponent as SvgChevronDown} from './tabler/outline/chevron-down.svg';
import {ReactComponent as SvgChevronLeft} from './tabler/outline/chevron-left.svg';
import {ReactComponent as SvgChevronRight} from './tabler/outline/chevron-right.svg';
import {ReactComponent as SvgChevronUp} from './tabler/outline/chevron-up.svg';
import {ReactComponent as SvgCircleCheck} from './tabler/outline/circle-check.svg';
import {ReactComponent as SvgCircleCheckFilled} from './tabler/filled/circle-check.svg';
import {ReactComponent as SvgCircleX} from './tabler/outline/circle-x.svg';
import {ReactComponent as SvgClipboard} from './tabler/outline/clipboard.svg';
import {ReactComponent as SvgClock} from './tabler/outline/clock.svg';
import {ReactComponent as SvgCloudOff} from './tabler/outline/cloud-off.svg';
import {ReactComponent as SvgCode} from './tabler/outline/code.svg';
import {ReactComponent as SvgCopy} from './tabler/outline/copy.svg';
import {ReactComponent as SvgCpu} from './tabler/outline/cpu.svg';
import {ReactComponent as SvgCurrencyDollar} from './tabler/outline/currency-dollar.svg';
import {ReactComponent as SvgDatabase} from './tabler/outline/database.svg';
import {ReactComponent as SvgDeviceMobile} from './tabler/outline/device-mobile.svg';
import {ReactComponent as SvgDotsVertical} from './tabler/outline/dots-vertical.svg';
import {ReactComponent as SvgDownload} from './tabler/outline/download.svg';
import {ReactComponent as SvgEdit} from './tabler/outline/edit.svg';
import {ReactComponent as SvgExternalLink} from './tabler/outline/external-link.svg';
import {ReactComponent as SvgEye} from './tabler/outline/eye.svg';
import {ReactComponent as SvgEyeOff} from './tabler/outline/eye-off.svg';
import {ReactComponent as SvgFile} from './tabler/outline/file.svg';
import {ReactComponent as SvgFilePlus} from './tabler/outline/file-plus.svg';
import {ReactComponent as SvgFileText} from './tabler/outline/file-text.svg';
import {ReactComponent as SvgFilter} from './tabler/outline/filter.svg';
import {ReactComponent as SvgGlobe} from './tabler/outline/globe.svg';
import {ReactComponent as SvgGripVertical} from './tabler/outline/grip-vertical.svg';
import {ReactComponent as SvgHash} from './tabler/outline/hash.svg';
import {ReactComponent as SvgHelpCircle} from './tabler/outline/help-circle.svg';
import {ReactComponent as SvgHome} from './tabler/outline/home.svg';
import {ReactComponent as SvgInfoCircle} from './tabler/outline/info-circle.svg';
import {ReactComponent as SvgKey} from './tabler/outline/key.svg';
import {ReactComponent as SvgLayout} from './tabler/outline/layout.svg';
import {ReactComponent as SvgList} from './tabler/outline/list.svg';
import {ReactComponent as SvgLoader} from './tabler/outline/loader.svg';
import {ReactComponent as SvgLock} from './tabler/outline/lock.svg';
import {ReactComponent as SvgLogout} from './tabler/outline/logout.svg';
import {ReactComponent as SvgMail} from './tabler/outline/mail.svg';
import {ReactComponent as SvgMapPin} from './tabler/outline/map-pin.svg';
import {ReactComponent as SvgMenu2} from './tabler/outline/menu-2.svg';
import {ReactComponent as SvgMessage} from './tabler/outline/message.svg';
import {ReactComponent as SvgMessageCircle} from './tabler/outline/message-circle.svg';
import {ReactComponent as SvgMicrophone} from './tabler/outline/microphone.svg';
import {ReactComponent as SvgMicrophoneOff} from './tabler/outline/microphone-off.svg';
import {ReactComponent as SvgPaperclip} from './tabler/outline/paperclip.svg';
import {ReactComponent as SvgPhone} from './tabler/outline/phone.svg';
import {ReactComponent as SvgPhoneCall} from './tabler/outline/phone-call.svg';
import {ReactComponent as SvgPhoneOff} from './tabler/outline/phone-off.svg';
import {ReactComponent as SvgPlayerPause} from './tabler/outline/player-pause.svg';
import {ReactComponent as SvgPlayerPlay} from './tabler/outline/player-play.svg';
import {ReactComponent as SvgPlayerSkipBack} from './tabler/outline/player-skip-back.svg';
import {ReactComponent as SvgPlayerSkipForward} from './tabler/outline/player-skip-forward.svg';
import {ReactComponent as SvgPlayerTrackNext} from './tabler/outline/player-track-next.svg';
import {ReactComponent as SvgPlus} from './tabler/outline/plus.svg';
import {ReactComponent as SvgPrinter} from './tabler/outline/printer.svg';
import {ReactComponent as SvgRefresh} from './tabler/outline/refresh.svg';
import {ReactComponent as SvgRotate} from './tabler/outline/rotate.svg';
import {ReactComponent as SvgSearch} from './tabler/outline/search.svg';
import {ReactComponent as SvgSend} from './tabler/outline/send.svg';
import {ReactComponent as SvgServer} from './tabler/outline/server.svg';
import {ReactComponent as SvgSettings} from './tabler/outline/settings.svg';
import {ReactComponent as SvgShield} from './tabler/outline/shield.svg';
import {ReactComponent as SvgSlash} from './tabler/outline/slash.svg';
import {ReactComponent as SvgSquare} from './tabler/outline/square.svg';
import {ReactComponent as SvgStack2} from './tabler/outline/stack-2.svg';
import {ReactComponent as SvgStar} from './tabler/outline/star.svg';
import {ReactComponent as SvgStarFilled} from './tabler/filled/star.svg';
import {ReactComponent as SvgStethoscope} from './tabler/outline/stethoscope.svg';
import {ReactComponent as SvgSunglasses} from './tabler/outline/sunglasses.svg';
import {ReactComponent as SvgTarget} from './tabler/outline/target.svg';
import {ReactComponent as SvgTerminal} from './tabler/outline/terminal.svg';
import {ReactComponent as SvgTool} from './tabler/outline/tool.svg';
import {ReactComponent as SvgTrash} from './tabler/outline/trash.svg';
import {ReactComponent as SvgTrendingUp} from './tabler/outline/trending-up.svg';
import {ReactComponent as SvgTypography} from './tabler/outline/typography.svg';
import {ReactComponent as SvgUpload} from './tabler/outline/upload.svg';
import {ReactComponent as SvgUser} from './tabler/outline/user.svg';
import {ReactComponent as SvgUserCheck} from './tabler/outline/user-check.svg';
import {ReactComponent as SvgUserPlus} from './tabler/outline/user-plus.svg';
import {ReactComponent as SvgUserX} from './tabler/outline/user-x.svg';
import {ReactComponent as SvgUsers} from './tabler/outline/users.svg';
import {ReactComponent as SvgVideo} from './tabler/outline/video.svg';
import {ReactComponent as SvgVolume2} from './tabler/outline/volume-2.svg';
import {ReactComponent as SvgVolumeOff} from './tabler/outline/volume-off.svg';
import {ReactComponent as SvgWand} from './tabler/outline/wand.svg';
import {ReactComponent as SvgX} from './tabler/outline/x.svg';

const FallbackIcon = React.forwardRef(
  (
    {
      as: Svg,
      boxSize,
      color,
      focusable,
      strokeWidth,
      style,
      sx,
      ...props
    }: Record<string, any>,
    ref: any,
  ) => {
    const size = typeof boxSize === 'number' ? `${boxSize}px` : boxSize;
    const resolvedStyle = {
      color,
      width: size,
      height: size,
      ...style,
    };

    if (typeof Svg === 'function') {
      return (
        <Svg ref={ref} focusable={focusable} style={resolvedStyle} {...props} />
      );
    }

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth ?? 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        focusable={focusable}
        style={resolvedStyle}
        {...props}
      />
    );
  },
);
FallbackIcon.displayName = 'FallbackTablerIcon';

const IconBase = ChakraIcon || FallbackIcon;

const createTablerIcon = (Svg: any, displayName: any) => {
  const TablerIcon = React.forwardRef(
    (
      {size, boxSize, strokeWidth, sx, ...props}: Record<string, any>,
      ref: any,
    ) => {
      const resolvedBoxSize =
        boxSize ??
        (size == null
          ? undefined
          : typeof size === 'number'
            ? `${size}px`
            : size);
      const strokeSx =
        strokeWidth == null
          ? undefined
          : {
              '& path, & circle, & rect, & line, & polyline, & polygon': {
                strokeWidth,
              },
            };

      return (
        <IconBase
          ref={ref}
          as={Svg}
          boxSize={resolvedBoxSize}
          focusable="false"
          aria-hidden="true"
          sx={strokeSx ? {...strokeSx, ...sx} : sx}
          {...props}
        />
      );
    },
  );
  TablerIcon.displayName = displayName;
  return TablerIcon;
};

export const TablerActivity = createTablerIcon(SvgActivity, 'ActivityIcon');
export const TablerAdjustmentsHorizontal = createTablerIcon(
  SvgAdjustmentsHorizontal,
  'AdjustmentsHorizontalIcon',
);
export const TablerAlertCircle = createTablerIcon(
  SvgAlertCircle,
  'AlertCircleIcon',
);
export const TablerAlertOctagon = createTablerIcon(
  SvgAlertOctagon,
  'AlertOctagonIcon',
);
export const TablerAlertTriangle = createTablerIcon(
  SvgAlertTriangle,
  'AlertTriangleIcon',
);
export const TablerArrowLeft = createTablerIcon(SvgArrowLeft, 'ArrowLeftIcon');
export const TablerArrowRight = createTablerIcon(
  SvgArrowRight,
  'ArrowRightIcon',
);
export const TablerArrowUp = createTablerIcon(SvgArrowUp, 'ArrowUpIcon');
export const TablerArrowUpRight = createTablerIcon(
  SvgArrowUpRight,
  'ArrowUpRightIcon',
);
export const TablerAward = createTablerIcon(SvgAward, 'AwardIcon');
export const TablerBolt = createTablerIcon(SvgBolt, 'BoltIcon');
export const TablerBook = createTablerIcon(SvgBook, 'BookIcon');
export const TablerBraces = createTablerIcon(SvgBraces, 'BracesIcon');
export const TablerBriefcase = createTablerIcon(SvgBriefcase, 'BriefcaseIcon');
export const TablerBrandWindows = createTablerIcon(
  SvgBrandWindows,
  'BrandWindowsIcon',
);
export const TablerBuilding = createTablerIcon(SvgBuilding, 'BuildingIcon');
export const TablerCalendar = createTablerIcon(SvgCalendar, 'CalendarIcon');
export const TablerCalendarClock = createTablerIcon(
  SvgCalendarClock,
  'CalendarClockIcon',
);
export const TablerChartBar = createTablerIcon(SvgChartBar, 'ChartBarIcon');
export const TablerCheck = createTablerIcon(SvgCheck, 'CheckIcon');
export const TablerChevronDown = createTablerIcon(
  SvgChevronDown,
  'ChevronDownIcon',
);
export const TablerChevronLeft = createTablerIcon(
  SvgChevronLeft,
  'ChevronLeftIcon',
);
export const TablerChevronRight = createTablerIcon(
  SvgChevronRight,
  'ChevronRightIcon',
);
export const TablerChevronUp = createTablerIcon(SvgChevronUp, 'ChevronUpIcon');
export const TablerCircleCheck = createTablerIcon(
  SvgCircleCheck,
  'CircleCheckIcon',
);
export const TablerCircleCheckFilled = createTablerIcon(
  SvgCircleCheckFilled,
  'CircleCheckFilledIcon',
);
export const TablerCircleX = createTablerIcon(SvgCircleX, 'CircleXIcon');
export const TablerClipboard = createTablerIcon(SvgClipboard, 'ClipboardIcon');
export const TablerClock = createTablerIcon(SvgClock, 'ClockIcon');
export const TablerCloudOff = createTablerIcon(SvgCloudOff, 'CloudOffIcon');
export const TablerCode = createTablerIcon(SvgCode, 'CodeIcon');
export const TablerCopy = createTablerIcon(SvgCopy, 'CopyIcon');
export const TablerCpu = createTablerIcon(SvgCpu, 'CpuIcon');
export const TablerCurrencyDollar = createTablerIcon(
  SvgCurrencyDollar,
  'CurrencyDollarIcon',
);
export const TablerDatabase = createTablerIcon(SvgDatabase, 'DatabaseIcon');
export const TablerDeviceMobile = createTablerIcon(
  SvgDeviceMobile,
  'DeviceMobileIcon',
);
export const TablerDotsVertical = createTablerIcon(
  SvgDotsVertical,
  'DotsVerticalIcon',
);
export const TablerDownload = createTablerIcon(SvgDownload, 'DownloadIcon');
export const TablerEdit = createTablerIcon(SvgEdit, 'EditIcon');
export const TablerExternalLink = createTablerIcon(
  SvgExternalLink,
  'ExternalLinkIcon',
);
export const TablerEye = createTablerIcon(SvgEye, 'EyeIcon');
export const TablerEyeOff = createTablerIcon(SvgEyeOff, 'EyeOffIcon');
export const TablerFile = createTablerIcon(SvgFile, 'FileIcon');
export const TablerFilePlus = createTablerIcon(SvgFilePlus, 'FilePlusIcon');
export const TablerFileText = createTablerIcon(SvgFileText, 'FileTextIcon');
export const TablerFilter = createTablerIcon(SvgFilter, 'FilterIcon');
export const TablerGlobe = createTablerIcon(SvgGlobe, 'GlobeIcon');
export const TablerGripVertical = createTablerIcon(
  SvgGripVertical,
  'GripVerticalIcon',
);
export const TablerHash = createTablerIcon(SvgHash, 'HashIcon');
export const TablerHelpCircle = createTablerIcon(
  SvgHelpCircle,
  'HelpCircleIcon',
);
export const TablerHome = createTablerIcon(SvgHome, 'HomeIcon');
export const TablerInfoCircle = createTablerIcon(
  SvgInfoCircle,
  'InfoCircleIcon',
);
export const TablerKey = createTablerIcon(SvgKey, 'KeyIcon');
export const TablerLayout = createTablerIcon(SvgLayout, 'LayoutIcon');
export const TablerList = createTablerIcon(SvgList, 'ListIcon');
export const TablerLoader = createTablerIcon(SvgLoader, 'LoaderIcon');
export const TablerLock = createTablerIcon(SvgLock, 'LockIcon');
export const TablerLogout = createTablerIcon(SvgLogout, 'LogoutIcon');
export const TablerMail = createTablerIcon(SvgMail, 'MailIcon');
export const TablerMapPin = createTablerIcon(SvgMapPin, 'MapPinIcon');
export const TablerMenu2 = createTablerIcon(SvgMenu2, 'Menu2Icon');
export const TablerMessage = createTablerIcon(SvgMessage, 'MessageIcon');
export const TablerMessageCircle = createTablerIcon(
  SvgMessageCircle,
  'MessageCircleIcon',
);
export const TablerMicrophone = createTablerIcon(
  SvgMicrophone,
  'MicrophoneIcon',
);
export const TablerMicrophoneOff = createTablerIcon(
  SvgMicrophoneOff,
  'MicrophoneOffIcon',
);
export const TablerPaperclip = createTablerIcon(SvgPaperclip, 'PaperclipIcon');
export const TablerPhone = createTablerIcon(SvgPhone, 'PhoneIcon');
export const TablerPhoneCall = createTablerIcon(SvgPhoneCall, 'PhoneCallIcon');
export const TablerPhoneOff = createTablerIcon(SvgPhoneOff, 'PhoneOffIcon');
export const TablerPlayerPause = createTablerIcon(
  SvgPlayerPause,
  'PlayerPauseIcon',
);
export const TablerPlayerPlay = createTablerIcon(
  SvgPlayerPlay,
  'PlayerPlayIcon',
);
export const TablerPlayerSkipBack = createTablerIcon(
  SvgPlayerSkipBack,
  'PlayerSkipBackIcon',
);
export const TablerPlayerSkipForward = createTablerIcon(
  SvgPlayerSkipForward,
  'PlayerSkipForwardIcon',
);
export const TablerPlayerTrackNext = createTablerIcon(
  SvgPlayerTrackNext,
  'PlayerTrackNextIcon',
);
export const TablerPlus = createTablerIcon(SvgPlus, 'PlusIcon');
export const TablerPrinter = createTablerIcon(SvgPrinter, 'PrinterIcon');
export const TablerRefresh = createTablerIcon(SvgRefresh, 'RefreshIcon');
export const TablerRotate = createTablerIcon(SvgRotate, 'RotateIcon');
export const TablerSearch = createTablerIcon(SvgSearch, 'SearchIcon');
export const TablerSend = createTablerIcon(SvgSend, 'SendIcon');
export const TablerServer = createTablerIcon(SvgServer, 'ServerIcon');
export const TablerSettings = createTablerIcon(SvgSettings, 'SettingsIcon');
export const TablerShield = createTablerIcon(SvgShield, 'ShieldIcon');
export const TablerSlash = createTablerIcon(SvgSlash, 'SlashIcon');
export const TablerSquare = createTablerIcon(SvgSquare, 'SquareIcon');
export const TablerStack2 = createTablerIcon(SvgStack2, 'Stack2Icon');
export const TablerStar = createTablerIcon(SvgStar, 'StarIcon');
export const TablerStarFilled = createTablerIcon(
  SvgStarFilled,
  'StarFilledIcon',
);
export const TablerStethoscope = createTablerIcon(
  SvgStethoscope,
  'StethoscopeIcon',
);
export const TablerSunglasses = createTablerIcon(
  SvgSunglasses,
  'SunglassesIcon',
);
export const TablerTarget = createTablerIcon(SvgTarget, 'TargetIcon');
export const TablerTerminal = createTablerIcon(SvgTerminal, 'TerminalIcon');
export const TablerTool = createTablerIcon(SvgTool, 'ToolIcon');
export const TablerTrash = createTablerIcon(SvgTrash, 'TrashIcon');
export const TablerTrendingUp = createTablerIcon(
  SvgTrendingUp,
  'TrendingUpIcon',
);
export const TablerTypography = createTablerIcon(
  SvgTypography,
  'TypographyIcon',
);
export const TablerUpload = createTablerIcon(SvgUpload, 'UploadIcon');
export const TablerUser = createTablerIcon(SvgUser, 'UserIcon');
export const TablerUserCheck = createTablerIcon(SvgUserCheck, 'UserCheckIcon');
export const TablerUserPlus = createTablerIcon(SvgUserPlus, 'UserPlusIcon');
export const TablerUserX = createTablerIcon(SvgUserX, 'UserXIcon');
export const TablerUsers = createTablerIcon(SvgUsers, 'UsersIcon');
export const TablerVideo = createTablerIcon(SvgVideo, 'VideoIcon');
export const TablerVolume2 = createTablerIcon(SvgVolume2, 'Volume2Icon');
export const TablerVolumeOff = createTablerIcon(SvgVolumeOff, 'VolumeOffIcon');
export const TablerWand = createTablerIcon(SvgWand, 'WandIcon');
export const TablerX = createTablerIcon(SvgX, 'XIcon');

export const AccordionIcon = TablerChevronDown;
export const AlertIcon = TablerAlertCircle;
export const AlertTriangle = TablerAlertTriangle;
export const ArrowLeft = TablerArrowLeft;
export const ArrowRight = TablerArrowRight;
export const ArrowUp = TablerArrowUp;
export const ArrowUpRight = TablerArrowUpRight;
export const BookOpen = TablerBook;
export const Braces = TablerBraces;
export const BrandWindows = TablerBrandWindows;
export const Building = TablerBuilding;
export const CalendarClock = TablerCalendarClock;
export const Check = TablerCheck;
export const CheckCircle = TablerCircleCheck;
export const CheckCircleFilled = TablerCircleCheckFilled;
export const CheckCircleIcon = TablerCircleCheck;
export const ChevronDown = TablerChevronDown;
export const ChevronLeft = TablerChevronLeft;
export const ChevronRight = TablerChevronRight;
export const ChevronUp = TablerChevronUp;
export const Code = TablerCode;
export const Copy = TablerCopy;
export const Download = TablerDownload;
export const Eye = TablerEye;
export const EyeOff = TablerEyeOff;
export const FaEye = TablerEye;
export const FaEyeSlash = TablerEyeOff;
export const FiActivity = TablerActivity;
export const FiAlertCircle = TablerAlertCircle;
export const FiAlertOctagon = TablerAlertOctagon;
export const FiAlertTriangle = TablerAlertTriangle;
export const FiArrowLeft = TablerArrowLeft;
export const FiArrowRight = TablerArrowRight;
export const FiArrowUp = TablerArrowUp;
export const FiAward = TablerAward;
export const FiBarChart2 = TablerChartBar;
export const FiBook = TablerBook;
export const FiBriefcase = TablerBriefcase;
export const FiCalendar = TablerCalendar;
export const FiCheck = TablerCheck;
export const FiCheckCircle = TablerCircleCheck;
export const FiChevronDown = TablerChevronDown;
export const FiChevronLeft = TablerChevronLeft;
export const FiChevronRight = TablerChevronRight;
export const FiChevronUp = TablerChevronUp;
export const FiClipboard = TablerClipboard;
export const FiClock = TablerClock;
export const FiCloudOff = TablerCloudOff;
export const FiCopy = TablerCopy;
export const FiCpu = TablerCpu;
export const FiDatabase = TablerDatabase;
export const FiDollarSign = TablerCurrencyDollar;
export const FiDownload = TablerDownload;
export const FiEdit = TablerEdit;
export const FiEdit2 = TablerEdit;
export const FiEdit3 = TablerEdit;
export const FiExternalLink = TablerExternalLink;
export const FiEye = TablerEye;
export const FiEyeOff = TablerEyeOff;
export const FiFastForward = TablerPlayerTrackNext;
export const FiFile = TablerFile;
export const FiFilePlus = TablerFilePlus;
export const FiFileText = TablerFileText;
export const FiFilter = TablerFilter;
export const FiGlobe = TablerGlobe;
export const FiHash = TablerHash;
export const FiHelpCircle = TablerHelpCircle;
export const FiHome = TablerHome;
export const FiInfo = TablerInfoCircle;
export const FiKey = TablerKey;
export const FiLayers = TablerStack2;
export const FiLayout = TablerLayout;
export const FileText = TablerFileText;
export const FiList = TablerList;
export const FiLock = TablerLock;
export const FiMail = TablerMail;
export const FiMapPin = TablerMapPin;
export const FiMessageCircle = TablerMessageCircle;
export const FiMessageSquare = TablerMessage;
export const FiMic = TablerMicrophone;
export const FiMoreVertical = TablerDotsVertical;
export const FiPaperclip = TablerPaperclip;
export const FiPause = TablerPlayerPause;
export const FiPhone = TablerPhone;
export const FiPlay = TablerPlayerPlay;
export const FiPlayCircle = TablerPlayerPlay;
export const FiPlus = TablerPlus;
export const FiRefreshCw = TablerRefresh;
export const FiRotateCcw = TablerRotate;
export const FiSearch = TablerSearch;
export const FiSend = TablerSend;
export const FiServer = TablerServer;
export const FiSettings = TablerSettings;
export const FiShield = TablerShield;
export const FiSkipBack = TablerPlayerSkipBack;
export const FiSkipForward = TablerPlayerSkipForward;
export const FiSlash = TablerSlash;
export const FiSliders = TablerAdjustmentsHorizontal;
export const FiSmartphone = TablerDeviceMobile;
export const FiSquare = TablerSquare;
export const FiStar = TablerStar;
export const FiTarget = TablerTarget;
export const FiTrash2 = TablerTrash;
export const FiTrendingUp = TablerTrendingUp;
export const FiType = TablerTypography;
export const FiUpload = TablerUpload;
export const FiUser = TablerUser;
export const FiUserCheck = TablerUserCheck;
export const FiUserPlus = TablerUserPlus;
export const FiUsers = TablerUsers;
export const FiUserX = TablerUserX;
export const FiVideo = TablerVideo;
export const FiVolume2 = TablerVolume2;
export const FiX = TablerX;
export const FiXCircle = TablerCircleX;
export const FiZap = TablerBolt;
export const Globe = TablerGlobe;
export const GripVertical = TablerGripVertical;
export const HelpCircle = TablerHelpCircle;
export const Home = TablerHome;
export const InfoIcon = TablerInfoCircle;
export const KeyRound = TablerKey;
export const Loader = TablerLoader;
export const LogOut = TablerLogout;
export const Mail = TablerMail;
export const MdBuild = TablerTool;
export const MdHome = TablerHome;
export const MdLogout = TablerLogout;
export const MdPerson = TablerUser;
export const MdShield = TablerShield;
export const Menu = TablerMenu2;
export const MessageSquare = TablerMessage;
export const Mic = TablerMicrophone;
export const MicOff = TablerMicrophoneOff;
export const Phone = TablerPhone;
export const PhoneCall = TablerPhoneCall;
export const PhoneOff = TablerPhoneOff;
export const Play = TablerPlayerPlay;
export const Plus = TablerPlus;
export const RotateCcw = TablerRotate;
export const Search = TablerSearch;
export const Search2Icon = TablerSearch;
export const Settings = TablerSettings;
export const Star = TablerStar;
export const StepIcon = TablerCheck;
export const Stethoscope = TablerStethoscope;
export const Terminal = TablerTerminal;
export const Trash2 = TablerTrash;
export const User = TablerUser;
export const Video = TablerVideo;
export const Volume2 = TablerVolume2;
export const VolumeX = TablerVolumeOff;
export const Wand = TablerWand;
export const Wrench = TablerTool;
export const X = TablerX;
